import { markRaw } from 'vue'
import Cookie from 'cookie-universal'
import NuxtCookieService from '~/libs/nuxt-cookie-service'
import { getCookieDomain } from '~/libs/cookie-domain'

export default defineNuxtPlugin(({ $pinia }) => {
  const nuxtApp = useNuxtApp()
  const { $config } = nuxtApp
  const cookieDomain = getCookieDomain($config)
  // markRaw: this is a service instance, not reactive state. Pinia 4 warns
  // (PINIA_R1006) on plugin-added plain objects it can't expose via storeToRefs().
  const lendioCookies = markRaw(new NuxtCookieService(Cookie(), cookieDomain))
  $pinia.use(() => ({ $lendioCookies: lendioCookies }))
  nuxtApp.provide('lendioCookies', lendioCookies)
})
